/* パスワードリセット画面 */
import React from 'react';
import ReactDOM from 'react-dom';
import Block from '../../molecules/Block';
import Text from '../../molecules/Text';
import Annotation from '../../atoms/Annotation';
import CenterButton from '../../atoms/CenterButton';

const PasswordReset: React.FC = () => {
  return (
    <>
      <div className="mt-5"></div>
      <Block
        label="パスワードリセット"
        content={
          <>
            <Annotation text="ご登録のメールアドレスにパスワードリセットの案内メールを送付します。" />
            <div className="mt-3"></div>
            <div>
              <Text
                id="email"
                label="メールアドレス"
                value=""
                placeholder="example@example.com"
                disabled={false}
                handleChange={() => {}}
              />
            </div>
          </>
        }
      />
      <div className="mt-5"></div>
      <CenterButton label="リセットメール送信" />
    </>
  );
};

if (document.getElementById('password-reset')) {
  ReactDOM.render(<PasswordReset />, document.getElementById('password-reset'));
}
